import { CUSTOMER_ACCESS_PURCHASE } from "../../constants";

export const shouldRenderButton = ({
  customerAccess,
  isAppAdoptionEnabled,
  isInStock,
  oosVariantsAreSelectable,
}) => {
  const isExcludedDueToAppAdoption =
    isAppAdoptionEnabled && customerAccess === CUSTOMER_ACCESS_PURCHASE;

  return (
    !isExcludedDueToAppAdoption &&
    oosVariantsAreSelectable &&
    isInStock !== null
  );
};
